import { render, staticRenderFns } from "./TaxFormLayout.vue?vue&type=template&id=59320e58&scoped=true"
import script from "./TaxFormLayout.vue?vue&type=script&lang=ts"
export * from "./TaxFormLayout.vue?vue&type=script&lang=ts"
import style0 from "./TaxFormLayout.vue?vue&type=style&index=0&id=59320e58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59320e58",
  null
  
)

export default component.exports